import OutletPage from "./OutletPage";

export default OutletPage;
